import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import Header from "../../containers/Header";
import MainLayout from "../../layouts/MainLayout";
import Footer from "../../containers/Footer";

import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
// For animations
import { Fade } from "react-awesome-reveal";

import MasterForm from "../../components/MultiStepForm/ClaimReport/MasterForm";

// Add more insurrances if need be 
const insurrances = [
  {
    id: 1,
    name: "auto",
    fullname: "Assurance Automobile",
    image:
      "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1659843101/car_m2l5jx.jpg",
  },
  ];

const ClaimReport = () => {
  const [showFormModal, setShowFormModal] = useState(false);
  const [activeObject, setActiveObject] = useState(null);

  const showModal = () => setShowFormModal(true);
  const hideModal = () => setShowFormModal(false);

  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Header
        caption={t("claim-report_page_header_title")}
        bgImg={
          "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1655461136/insurrances-img-header_mc60pr.svg"
        }
      />
      {/* The pages are the same so we use the same css  */}
      <MainLayout pageCSS="invoice-page">
        <h2 className="">{t("claim-report_page_caption_text")}</h2>

        <Modal show={showFormModal} onHide={hideModal} centered>
          {activeObject ? (
            <MasterForm
              id={activeObject.id}
              fullname={activeObject.fullname}
              claimreportName={activeObject.name}
            />
          ) : null}

          <Modal.Footer>
            <Button variant="red" onClick={hideModal}>
              {t("modal_close_button")}
            </Button>
            {/* <Button variant="blue" onClick={hideModal}>
            Save Changes
          </Button> */}
          </Modal.Footer>
        </Modal>
        <Container>
          <Row>
            <Fade
              triggerOnce
              cascade
              direction="right"
              className="col col-md-4"
            >
              {insurrances?.map((insurrance) => (
                <Col key={insurrance.id} className="d-flex">
                  <Card
                    style={{ width: "46rem" }}
                    onClick={() => {
                      setActiveObject(insurrance);
                      showModal();
                    }}
                  >
                    <Card.Img
                      variant="top"
                      src={insurrance.image}
                      style={{ height: "28rem" }}
                    ></Card.Img>
                    <Card.Title
                      style={{
                        fontSize: "2rem",
                        display: "flex",
                        justifyContent: "center",
                        height: "5rem",
                        alignItems: "center",
                      }}
                    >
                      {insurrance.fullname}
                    </Card.Title>
                  </Card>
                </Col>
              ))}
            </Fade>
          </Row>
        </Container>
      </MainLayout>
      <Footer />
    </motion.div>
  );
};

export default ClaimReport;
